import { Box, Button, Grid, Icon, Typography } from "@mui/material";
import { AIOption } from "../AI-Types";

type Props = {
    item: AIOption,
    selected: boolean,
    onSelect: (option: AIOption) => void
}

const OptionItem = ({ item, selected, onSelect }: Props) => {
    return (
        <Grid item xs={12} md={2} sx={{ minHeigt: 130 }}>
            <Button variant={selected ? 'contained' : 'outlined'} sx={{ height: 130 }} fullWidth size="small" onClick={() => onSelect(item)}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: 2, pt: 2, pb: 2 }}>
                    <Icon fontSize='large'>
                        {item.icon}
                    </Icon>
                    <Typography variant="caption">{item.name}</Typography>
                </Box>
            </Button>
        </Grid>
    )

}

export default OptionItem;